import {AxiosResponse} from "axios";

const LOGIN_ERROR_STORAGE_KEY = "dashboardLoginErrorMessage";
export const LOGIN_ERROR_ROUTE = "/LoginError";
const DEFAULT_LOGIN_ERROR_MESSAGE = "We couldn't complete your login. Please try again.";

interface ErrorPayload {
  response?: string | string[];
  message?: string | string[];
  errorMessage?: string | string[];
}

const normalizeMessage = (value?: string | string[]) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean).join(" ");
  }

  if (typeof value === "string") {
    return value.trim();
  }

  return "";
};

export const extractAuthLoginErrorMessage = (error: AxiosResponse | undefined) => {
  const payload = error?.data as ErrorPayload | undefined;

  return (
    normalizeMessage(payload?.response) ||
    normalizeMessage(payload?.message) ||
    normalizeMessage(payload?.errorMessage) ||
    DEFAULT_LOGIN_ERROR_MESSAGE
  );
};

export const storeAuthLoginErrorMessage = (message: string) => {
  sessionStorage.setItem(LOGIN_ERROR_STORAGE_KEY, message || DEFAULT_LOGIN_ERROR_MESSAGE);
};

export const hasStoredAuthLoginErrorMessage = () => {
  return Boolean(sessionStorage.getItem(LOGIN_ERROR_STORAGE_KEY));
};

export const clearSuiteManagerSession = () => {
  sessionStorage.removeItem("suiteManagerToken");
  sessionStorage.removeItem("suiteManagerRefresh");
  sessionStorage.removeItem("userData");
  sessionStorage.removeItem("auth_token");
};

export const isAuthLoginErrorRoute = (pathname = window.location.pathname) => {
  return pathname === LOGIN_ERROR_ROUTE;
};

export const setAuthLoginErrorState = (message: string) => {
  storeAuthLoginErrorMessage(message);
  clearSuiteManagerSession();
};

export const getStoredAuthLoginErrorMessage = () => {
  return sessionStorage.getItem(LOGIN_ERROR_STORAGE_KEY) || DEFAULT_LOGIN_ERROR_MESSAGE;
};

export const clearStoredAuthLoginErrorMessage = () => {
  sessionStorage.removeItem(LOGIN_ERROR_STORAGE_KEY);
};
